$giper_baza_app $mol_book2_catalog
	menu_title \Giper Baza
	param \section
	menu_foot /
		<= Source $mol_link_source
			uri \https://github.com/giper-dev/baza
		<= Status $giper_baza_status
	spreads *
		info <= Info $mol_frame
			title \💨 Giper Encyclopedy
			uri \https://page.hyoo.ru/#!=sy2u0y_9rb8zj
		glob <= Glob $giper_baza_glob_book
			addon_tools /
				<= Spread_close
		stat <= Stat $giper_baza_app_stat_list
			menu_tools /
				<= Spread_close
		slot <= Slot $giper_baza_auth_slot
			tools /
				<= Spread_close
	placeholders /
